import * as React from 'react'
import { ReservedSpot, Reserve } from '../../types/reservation'

export enum Modal {
  None,
  Regist,
  Edit,
  Reserve,
  Confirm,
  Cancel,
}

interface State {
  readonly modal: Modal
  readonly selectedTime: string
  readonly reservedSpot: ReservedSpot | null
  readonly cancelReservation: Reserve | null
  readonly spots: ReservedSpot[]
  readonly isMobile: boolean
}

export interface ReservationState extends State {
  readonly setState: React.Dispatch<React.SetStateAction<State>>
}

export function useReservationState(): ReservationState {
  const [state, setState] = React.useState<State>({
    modal: Modal.None,
    selectedTime: '',
    reservedSpot: null,
    cancelReservation: null,
    spots: [],
    isMobile: false,
  })
  return { ...state, setState }
}
